/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=47df251f&scoped=true"
var script = {}
import style0 from "./Layout.vue?vue&type=style&index=0&id=47df251f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_387906ce4ecacbd1e1278429d52c3372/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df251f",
  null
  
)

export default component.exports